import SelfResponseModel from '@/Models/selfResponseModel';
import apiClient from '@/Services/Clients/apiClient';

const SELF_RESPONSE_BASE_URL = 'api/selfresponse';

export default class SelfResponseService {

  public static getResponse = (responseId: string) => {

    const resourceUrl = `${SELF_RESPONSE_BASE_URL}/${responseId}`;

    return apiClient.get(resourceUrl);
  };

  public static createResponse = (responseDataModel: SelfResponseModel) => {

    const resourceUrl = SELF_RESPONSE_BASE_URL;
    return apiClient.post(resourceUrl, responseDataModel);
  };

  public static updateResponse = (responseDataModel: SelfResponseModel) => {

    const resourceUrl = `${SELF_RESPONSE_BASE_URL}/${responseDataModel.id}`;
    return apiClient.put(resourceUrl, responseDataModel);
  };

  public static deleteResponse = (responseId:string) => {

    const resourceUrl = `${SELF_RESPONSE_BASE_URL}/${responseId}`;
    return apiClient.delete(resourceUrl);
  };

  public static submitSelfResponse(responseId: string, responseDataModel: SelfResponseModel): Promise<SelfResponseModel> {
    const uri = `${SELF_RESPONSE_BASE_URL}/submit/${responseId}`;
    return apiClient.post(uri, responseDataModel);
  }

  public static selfResponseHasUploadMetadata(responseId: string): Promise<boolean> {
    const uri = `${SELF_RESPONSE_BASE_URL}/${responseId}/hasuploadmetadata`;
    return apiClient.get(uri);
  }
}